// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Table = require("@mui/material/Table").default;
var Styles = require("@mui/material/styles");
var TableRow = require("@mui/material/TableRow").default;
var ParticleInfo$PdgLookup = require("../../lib/ParticleInfo.bs.js");
var TableBody = require("@mui/material/TableBody").default;
var TableCell = require("@mui/material/TableCell").default;

var infoBlock = Css.style({
      hd: Css.$$float("left"),
      tl: /* [] */0
    });

var infoLineName = Css.style({
      hd: Css.textAlign("left"),
      tl: {
        hd: Css.fontWeight("semiBold"),
        tl: /* [] */0
      }
    });

var infoLineProp = Css.style({
      hd: Css.textAlign("left"),
      tl: /* [] */0
    });

var cell = {
  borderColor: "white",
  minWidth: "0.1rem",
  padding: "5px"
};

var Styles$1 = {
  infoBlock: infoBlock,
  infoLineName: infoLineName,
  infoLineProp: infoLineProp,
  cell: cell
};

function getTableRow(param) {
  var p2 = param[1];
  var p1 = param[0];
  var getValue = function (p) {
    var u = p.units;
    if (u !== undefined) {
      return p.value + (" " + u);
    } else {
      return p.value;
    }
  };
  return JsxRuntime.jsxs(TableRow, {
              children: [
                JsxRuntime.jsx(TableCell, {
                      style: cell,
                      variant: "head",
                      children: Caml_option.some(p1.property)
                    }),
                JsxRuntime.jsx(TableCell, {
                      style: cell,
                      children: Caml_option.some(getValue(p1))
                    }),
                JsxRuntime.jsx(TableCell, {
                      style: cell,
                      variant: "head",
                      children: Caml_option.some(p2.property)
                    }),
                JsxRuntime.jsx(TableCell, {
                      style: cell,
                      children: Caml_option.some(getValue(p2))
                    })
              ]
            });
}

function getTable(particle) {
  var infoPairs = ParticleInfo$PdgLookup.getProperties(particle);
  var midPoint = (infoPairs.length >> 1);
  var firstHalf = Belt_Array.slice(infoPairs, 0, midPoint);
  var secondHalf = Belt_Array.slice(infoPairs, midPoint, infoPairs.length - midPoint | 0);
  return Belt_Array.map(Belt_Array.zip(firstHalf, secondHalf), getTableRow);
}

function InfoTable(props) {
  return JsxRuntime.jsx(Styles.ThemeProvider, {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Table, {
                          children: Caml_option.some(JsxRuntime.jsx(TableBody, {
                                    children: Caml_option.some(getTable(props.particle))
                                  })),
                          size: "small"
                        }),
                    className: infoBlock
                  }),
              theme: Styles.createTheme({})
            });
}

var make = InfoTable;

exports.Styles = Styles$1;
exports.getTableRow = getTableRow;
exports.getTable = getTable;
exports.make = make;
/* infoBlock Not a pure module */
